import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HideGtSmall, HideLarge, HideLtLarge, HideSmall, MediaQueryDirectiveLarge, MediaQueryDirectiveLTLarge, MediaQueryDirectiveSmall } from './media-query.directive';



@NgModule({
  declarations: [
    HideGtSmall,
    HideLarge,
    HideSmall,
    HideLtLarge,
    MediaQueryDirectiveSmall,
    MediaQueryDirectiveLarge,
    MediaQueryDirectiveLTLarge
  ],
  imports: [
    CommonModule,

  ],
  exports:[
    HideGtSmall,
    HideLarge,
    HideSmall,
    HideLtLarge,
    MediaQueryDirectiveLarge,
    MediaQueryDirectiveSmall,
    MediaQueryDirectiveLTLarge
  ]

})
export class MediaQueryModule { }
